
define('text!common/views/commercial/external-content.html',[],function () { return '<div class="fc-container fc-container--<%=widgetType%> hide-on-childrens-books-site js-<%=widgetType%>">\n    <div class="fc-container__inner js-<%=widgetType%>-container"></div>\n</div>\n';});

